import React, { useEffect, useState } from "react";

import { Row, Col, Container, Form, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

import logo from "../../assets/images/logo-sm.svg";
import CarouselPage from "../../shared/base-components/Carausel";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import { LoginRequest, schema } from "./Authentication.constants";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  isLoggedInSelector,
  permissionsSelector,
} from "../../shared/actions/Authentication.actions";
import { useAuthenticationLoginMutation } from "./Authentication.actions";
import useCookie from "../../shared/hooks/useCookie";
import paths from "../../shared/route/paths";
import { errorNotify } from "../../shared/utils/notifications";

import FeatherIcon from "feather-icons-react";
import { postMessageCall, postMessageLogin } from "../../shared/internals/asd";

const Login = () => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const navigate = useNavigate();

  const [permissionList, setPermissionList] =
    useRecoilState(permissionsSelector);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginRequest>({ resolver: yupResolver(schema) });

  const { data, mutate, isLoading } = useAuthenticationLoginMutation();

  const [passwordShow, setPasswordShow] = useState(false);
  const setIsLoggedIn = useSetRecoilState(isLoggedInSelector);
  const [, setAuthToken] = useCookie("token");
  const [rememberMe, setRemembetMe] = useCookie("rememberme");
  const [rememberEmail, setRememberEmail] = useCookie("user");
  const [rememberPassword, setRememberPassword] = useCookie("permissions");

  const onSubmit: SubmitHandler<any> = (requestValues) => {
    if (rememberMe === "true") {
      setRememberEmail(requestValues.email, 9999999);
      setRememberPassword(requestValues.password, 99999999);
    }

    mutate(requestValues);
  };

  useEffect(() => {
    if (data?.permissions) {
      let permissionsObj: any = [];

      data?.permissions.forEach((key: string) => {
        if (permissionList.hasOwnProperty(key)) {
          permissionsObj[key] = true;
        }
      });
      setPermissionList(permissionsObj);

      navigate(paths.DASHBOARD);
    }

    if (data?.access) {
      data?.access && setAuthToken(data?.access, 90);

      setIsLoggedIn({
        isLoggedIn: true,
        profile: data.user,
        company: data.company,
      });
    }

    if (data?.detail?.length) {
      errorNotify(data.detail);
    }
  }, [data]);

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div
                className={
                  isMobile
                    ? "auth-full-page-content-mobile d-flex p-sm-5 p-4"
                    : "auth-full-page-content d-flex p-sm-5 p-4"
                }
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <div className="d-block auth-logo">
                        <img src={logo} alt="" height="28" />
                        <span className="logo-txt">Ezrak</span>
                      </div>
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Hoşgeldiniz !</h5>
                        <p className="text-muted mt-2">
                          Devam etmek için ezrak uygulamasına giriş yapın.
                        </p>
                      </div>
                      <Form
                        onSubmit={handleSubmit(onSubmit)}
                        className="custom-form mt-4 pt-2"
                      >
                        <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <TextField
                            control={control}
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder="Email"
                            error={errors.email?.message}
                            defaultValue={
                              rememberMe === "true" ? rememberEmail : ""
                            }
                          />
                        </div>

                        <div className="mb-3">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <Label className="form-label">Şifre</Label>
                            </div>
                            {/* <div className="flex-shrink-0">
                              <div className="">
                                <Link
                                  to="/page-recoverpw"
                                  className="text-muted"
                                >
                                  Şifre mi unuttum ?
                                </Link>
                              </div>
                            </div> */}
                          </div>

                          <div className="input-group auth-pass-inputgroup">
                            <TextField
                              control={control}
                              name="password"
                              className="form-control"
                              type={passwordShow ? "text" : "password"}
                              placeholder="Password"
                              setPasswordShow={setPasswordShow}
                              error={errors.password?.message}
                              defaultValue={
                                rememberMe === "true" ? rememberPassword : ""
                              }
                              passwordEye
                            />
                          </div>
                        </div>

                        <div className="row mb-4">
                          <div className="col">
                            <div className="form-check">
                              <input
                                onChange={(e) =>
                                  setRemembetMe(
                                    e.target.checked ? "true" : "false",
                                    9999
                                  )
                                }
                                className="form-check-input"
                                type="checkbox"
                                defaultChecked={rememberMe === "true"}
                                id="remember-check"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="remember-check"
                              >
                                Beni hatırla
                              </label>
                            </div>

                            <div className="mt-3 d-grid">
                              <Button
                                loading={isLoading}
                                text="Giriş Yap"
                                variant="primary"
                              />
                            </div>
                          </div>
                        </div>
                      </Form>
                      {isMobile && (
                        <div className="border-0 text-center mb-0 mt-5">
                          <div className="card-body">
                            <div className="mt-4">
                              <a
                                onClick={() => {
                                  postMessageCall("05397350756");
                                }}
                                href={"#"}
                                className="btn btn-light mt-2"
                              >
                                Bize Ulaşın <FeatherIcon icon="phone" />
                              </a>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} Ezrak . Tüm hakları{" "}
                        <i className="mdi mdi-heart text-danger"></i>{" "}
                        NebulaSoft'a aittir.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;
